export default __webpack_public_path__ + "static/chris-ffd77731bf7b7394d4cfa0891ad1a7ee.png";